<template>
  <div
    v-if="comments.length"
    class="comment-group d-flex flex-col md:flex-row mb-4 mt-4"
  >
    <div class="d-flex flex-column items-start md:items-center left-col">
      <div
        class="comment-group-timestamp d-flex flex-column items-start md:items-center"
      >
        <template v-if="pinned">
          <i class="fa-solid fa-thumbtack text-primary" />
          <span class="font-bold">Pinned</span>
        </template>
        <template v-else>
          <span class="font-bold">{{ dow }}</span>
          <span>{{ month }}</span>
        </template>
      </div>
      <div class="divider hidden md:block" />
    </div>
    <div class="group-comments full-width" data-cy="group-comments">
      <Comment
        v-for="comment in comments"
        :key="comment.id"
        :commentable-type="commentableType"
        :commentable-id="commentableId"
        :class="{ single: comments.length === 1 }"
        :comment="comment"
        :allow-edit="allowEdit"
        :show-date="pinned"
        v-bind="$attrs"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";

import Comment from "./Comment.vue";
export default {
  components: {
    Comment
  },
  props: {
    commentableType: {
      type: String,
      default: ""
    },
    commentableId: {
      type: Number,
      default: null
    },
    comments: {
      type: Array,
      default: () => []
    },
    date: { type: String, default: "" },
    allowEdit: { type: Boolean, default: true },
    pinned: { type: Boolean, default: false }
  },
  computed: {
    dow() {
      return moment(this.date).format("dddd");
    },
    month() {
      return moment(this.date).format("MMMM DD YYYY");
    }
  }
};
</script>

<style lang="scss">
.single {
  border-radius: 4px !important;
}
</style>
